import { REPORT_FEATURES } from '../data/content';
import './DynamicReports.css';

export default function DynamicReports() {
  return (
    <section id="reports" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Dynamic Reporting</span>
        <h2 className="sec-title">Insight into every conversation.</h2>
        <p className="sec-sub">
          Every Aiva bot comes with a built-in analytics suite. Track performance,
          measure ROI, and continuously improve — with real-time, filterable reports
          that give you complete visibility into your AI agent's impact.
        </p>

        {/* Dashboard preview mockup */}
        <div className="reports__preview">
          <div className="rp-header">
            <span className="rp-title">Chatbot Analytics Dashboard</span>
            <div className="rp-filters">
              <span className="rp-filter rp-filter--active">Today</span>
              <span className="rp-filter">This Week</span>
              <span className="rp-filter">This Month</span>
              <span className="rp-filter">Custom</span>
            </div>
          </div>
          <div className="rp-metrics">
            {[
              { label:'Total Conversations', value:'4,821', trend:'+12%', up:true },
              { label:'Resolved by Bot',     value:'3,927', trend:'+18%', up:true },
              { label:'Escalated to Agent',  value:'894',   trend:'-8%',  up:false },
              { label:'Avg Response Time',   value:'1.1s',  trend:'-22%', up:false },
              { label:'CSAT Score',          value:'4.7/5', trend:'+0.3', up:true },
              { label:'Deflection Rate',     value:'81%',   trend:'+5%',  up:true },
            ].map(m => (
              <div key={m.label} className="rp-metric">
                <div className="rp-metric__val">{m.value}</div>
                <div className="rp-metric__label">{m.label}</div>
                <div className={`rp-metric__trend ${m.up ? 'up':'down'}`}>{m.trend}</div>
              </div>
            ))}
          </div>
          <div className="rp-chart-row">
            <div className="rp-chart">
              <div className="rp-chart__label">Conversation volume — last 7 days</div>
              <div className="rp-bars">
                {[62,78,55,90,84,95,81].map((h,i) => (
                  <div key={i} className="rp-bar-col">
                    <div className="rp-bar" style={{height:`${h}%`}} />
                    <span className="rp-bar-day">{['M','T','W','T','F','S','S'][i]}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="rp-intents">
              <div className="rp-chart__label">Top query intents</div>
              {[
                { label:'Leave balance query',   pct:34 },
                { label:'Password reset',        pct:22 },
                { label:'Salary slip request',   pct:18 },
                { label:'IT ticket raise',       pct:14 },
                { label:'Policy questions',      pct:12 },
              ].map(it => (
                <div key={it.label} className="intent-row">
                  <span className="intent-label">{it.label}</span>
                  <div className="intent-track">
                    <div className="intent-fill" style={{width:`${it.pct}%`}} />
                  </div>
                  <span className="intent-pct">{it.pct}%</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Feature cards */}
        <div className="reports__grid">
          {REPORT_FEATURES.map(f => (
            <div key={f.title} className="report-card">
              <div className="report-card__icon">{f.icon}</div>
              <h3 className="report-card__title">{f.title}</h3>
              <p className="report-card__desc">{f.desc}</p>
              <div className="tags">
                {f.tags.map(t => <span key={t} className="tag blue">{t}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
